import { checkIsUserLoggedIn } from './check-is-user-logged-in';
import { openLoginView } from './open-login-view';

export const UtilsAccount = {
  openLoginView,
  checkIsUserLoggedIn
};
